/** A 24-hour `HH:mm` time as its 12-hour label, with noon and midnight spelled as words. */
export function convertTo12Hour(time24: string): string {
  if (!time24) return ''
  const [hourText, minutes = '00'] = time24.split(':')
  if (hourText === undefined || hourText.length === 0) return ''
  const hour = parseInt(hourText, 10)
  const ampm = hour >= 12 ? 'PM' : 'AM'
  const hour12 = hour % 12 || 12
  const str = `${hour12}:${minutes} ${ampm}`
  if (str === '12:00 PM') return 'Noon'
  if (str === '12:00 AM') return 'Midnight'
  return str
}
